import {ValidatorFn, AsyncValidatorFn, UntypedFormGroup, AbstractControl} from '@angular/forms';
import {CustomFormControl} from './CustomFormControl';

export class CustomFormGroup extends UntypedFormGroup {
  customFormControls: CustomFormControl[];

  constructor(
    controls: Record<string, AbstractControl>,
    customFormControls: CustomFormControl[],
    validatorOrOpts?: ValidatorFn | ValidatorFn[] | null,
    asyncValidator?: AsyncValidatorFn | AsyncValidatorFn[] | null
  ) {
    super(controls, validatorOrOpts, asyncValidator);
    this.customFormControls = customFormControls;
  }
}
